import { defineMessages } from 'react-intl';

const scope = 'cb.screens.Referrals';

export default defineMessages({
  expiresBadge: {
    id: `${scope}.expiresBadge`,
    defaultMessage: 'Expires: {date, date, ::dMMMyyyy}',
  },
});
